// extracted by mini-css-extract-plugin
export default {"editor":"ManageWidget_editor__7fH2R","editor_header":"ManageWidget_editor_header__JXg8R"};